import React, { useEffect, useState } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  handleMessageFormat,
  checkFormValidity,
} from "../../../../../helper/util";
import Spinner from "../../../../Common/Spinner";
import Notify from "../../../../Common/Notify";
import PatientInfo from "../PatientInfo";
import Subjective from "../Subjective";
import Objective from "../Objective";
import PlanText from "../PlanText";
import Orders from "../Plan";
import Assessment from "../Assessment";
import ChiefComplaints from "../ChiefComplaints";
import VitalSigns from "../VitalSigns";
import ProcedureNotes from "../ProcedureNotes";
import AddendumNote from "../AddendumNote";
import FollowUps from "../FollowUps";
import CptCode from "../CptCode";
import SaveChanges from "../SaveChanges";
import PrescriptionModal from "../../../../Conversation/Setting/PrescriptionModal";
import {
  createProgressNote,
  updateProgressNote,
  getProgressNotesPlans,
  getProgressNote,
  checkUncheckPlansArray,
  getProgressNoteDraft,
  draftProgressNote,
  updateDraftProgressNote,
} from "../../../../../actions/ProgressNotesAction";

import "../index.css";

const $ = window.$;

function SoapProgressNoteModal({
  isOpen = false,
  patientId = "",
  patientInfo = {},
  orgId = "",
  template = {},
  title = "",
  progressNoteId = "",
  isAddendumNote = false,
  groupMembers = [],
  tempMembers = [],
  guests = [],
  onClose = () => {},
  refreshData = () => {},
  errorNotification = () => {},
  setLocalStorageNull = () => {},
  isDraftSaving,
  setIsDraftSaving,
  draftId,
  handleUpdateDraftProgressNote = () => {},
  handleSaveAsDraftProgressNote = () => {},
}) {
  const dispatch = useDispatch();
  const { isUpdating, plansArray } = useSelector(mySelector, shallowEqual);
  const modalId = "#soap_progressnote_modal";
  const [temp, setTemplate] = useState(template);
  const [patient, setPatient] = useState(patientInfo);
  const [showSaveChanges, setShowSaveChanges] = useState(false);
  const [dataChanged, setDataChanged] = useState(false);
  const [rxModalShown, setRxModalShown] = useState(false);
  const {
    subjective = "",
    objective = "",
    chiefComplaints = [],
    vitalSigns = {},
    addendumNote = "",
    plan = "",
    assessment = "",
    dateSeen = "",
    visitProvider = "",
    clinicLocation = "",
    procedureNotes = "",
    encounterType = "",
    followUps = {},
    cptCode = "",
    planIds = [],
    labs = {
      prescription: "",
      diagnosticStudies: "",
      referrals: "",
      medicalSupplies: "",
    },
    favorites = [],
    modifierCode = "",
  } = temp;

  function handleSetDataChanged(data) {
    data.id = draftId || null;
    localStorage.setItem(`${patientId}_progressnote`, JSON.stringify(data));
    setDataChanged(true);
  }

  function handleUpdatePNdraft() {
    if (progressNoteId) return;
    setIsDraftSaving(true);
    if (draftId) {
      handleUpdateDraftProgressNote(draftId);
    } else {
      handleSaveAsDraftProgressNote();
    }
  }

  function handleUpdatePatientInfo(name, value) {
    const data = {
      ...patient,
      [name]: value,
    };
    setPatient(data);
    handleSetDataChanged(data);
  }

  function handleUpdateChiefComplaints(data) {
    const { chiefComplaints = [] } = temp;
    const newData = {
      ...temp,
      chiefComplaints: [...chiefComplaints, data],
    };
    setTemplate(newData);
    handleSetDataChanged(newData);
  }

  function handleUpdateVitalSigns(name, value) {
    const data = {
      ...temp,
      vitalSigns: {
        ...temp.vitalSigns,
        [name]: value,
      },
    };
    setTemplate(data);
    handleSetDataChanged(data);
  }

  function handleUpdateCptComp(name, value, subObptions) {
    if (name === "encounterType") {
      const data = {
        ...temp,
        [name]: value,
        cptCode: subObptions[0].options[0],
        modifierCode: "",
      };
      setTemplate(data);
      handleSetDataChanged(data);
    } else {
      const data = {
        ...temp,
        [name]: value,
      };
      setTemplate(data);
      handleSetDataChanged(data);
    }
  }

  function handleUpdateFollowUps(name, value) {
    const {
      followUps: { duration = [], in: fIn },
    } = temp;
    if (name !== "in" && name !== "duration") {
      const data = {
        ...temp,
        followUps: {
          ...temp.followUps,
          [name]: value,
        },
      };
      setTemplate(data);
      handleSetDataChanged(data);
    }

    if (name === "in") {
      const currentDate = new Date();
      const data = {
        ...temp,
        followUps: {
          ...temp.followUps,
          [name]: (parseInt(value) >= 100
            ? 99
            : parseInt(value) <= 0
            ? 0
            : value
          ).toString(),
          date:
            duration.length > 0
              ? currentDate.setDate(
                  currentDate.getDate() +
                    parseInt(value) * (duration[0].val || 0)
                )
              : currentDate,
        },
      };
      setTemplate(data);
      handleSetDataChanged(data);
    }

    if (name === "duration") {
      const currentDate = new Date();
      const data = {
        ...temp,
        followUps: {
          ...temp.followUps,
          [name]: value,
          date:
            value.length > 0
              ? currentDate.setDate(
                  currentDate.getDate() + parseInt(value[0].val) * (fIn || 0)
                )
              : currentDate,
        },
      };
      setTemplate(data);
      handleSetDataChanged(data);
    }
  }

  function handleUpdateField(e) {
    e.preventDefault();
    const { name, value } = e.target;
    const data = {
      ...temp,
      [name]: value,
    };
    setTemplate(data);
    handleSetDataChanged(data);
  }

  function handleClearField(name) {
    const data = {
      ...temp,
      [name]: "",
    };
    setTemplate(data);
    handleSetDataChanged(data);
  }

  function handleRemoveChiefComplaint(data) {
    const { chiefComplaints = [] } = temp;
    const filtered = chiefComplaints.filter((item) => item !== data);
    const newData = {
      ...temp,
      chiefComplaints: filtered,
    };
    setTemplate(newData);
    handleSetDataChanged(newData);
  }

  function handleClose() {
    localStorage.removeItem("someModalIsOpen");
    $(modalId).modal("hide");
  }

  function handleCreateProgressNote(doneObj = {}) {
    createProgressNote(
      {
        ...temp,
        ...doneObj,
        circleId: patientId,
      },
      orgId,
      draftId,
    )(dispatch).then(
      () => {
        Notify.success("Progress note successfully created.");
        setLocalStorageNull();
        handleClose();
        onClose();
        refreshData();
        setDataChanged(false);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  function handleUpdateProgressNote(status = {}) {
    delete temp["__type"];
    delete temp["className"];
    updateProgressNote(
      {
        ...temp,
        ...status,
      },
      progressNoteId
    )(dispatch).then(
      () => {
        Notify.success("Progress note successfully updated.");
        setLocalStorageNull();
        // handleClose();
        // onClose();
        refreshData();
        setDataChanged(false);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  function handleSaveChangesOnClose(bool, isValid) {
    if (bool) {
      if (!isValid) {
        errorNotification();
        setShowSaveChanges(false);
        return;
      }
      if (progressNoteId) {
        handleUpdateProgressNote();
      } else {
        handleCreateProgressNote();
      }
    } else {
      setDataChanged(false);
      handleClose();
      onClose();
      setLocalStorageNull();
    }
    setShowSaveChanges(false);
  }

  function handleUpdatePlans(name, value) {
    const data = {
      ...temp,
      labs: {
        ...temp.labs,
        [name]: value,
      },
    };
    setTemplate(data);
    handleSetDataChanged(data);
  }

  function handleUpdatePlansCheckbox(data, checked) {
    const { diagnosticStudies } = temp.labs;
    checkUncheckPlansArray(data.objectId, checked, plansArray)(dispatch);
    const newData = {
      ...temp,
      labs: {
        ...temp.labs,
        diagnosticStudies: checked
          ? addStr(`${diagnosticStudies}% ${data.name}`)
          : removeStr(diagnosticStudies, data.name),
      },
      planIds: filterPlanIds(planIds, data.objectId, checked),
    };
    setTemplate(newData);
    handleSetDataChanged(newData);

    function filterPlanIds(ids, id, checked) {
      const pIds = ids;

      if (checked) {
        pIds.push(id);
      } else if (!checked) {
        return pIds.filter((i) => i !== id);
      }
      return pIds;
    }

    function addStr(str) {
      return str
        .split("%")
        .filter(Boolean)
        .join(";");
    }

    function removeStr(ds, str) {
      const strData = ds.replace(str, "");
      return strData
        .split(";")
        .filter((entry) => {
          return entry.trim() !== "";
        })
        .join(";");
    }
  }

  function handleImportedPrescription(meds = []) {
    const data = {
      ...temp,
      labs: {
        ...temp.labs,
        prescription: `${temp.labs.prescription} ${handleMessageFormat(meds)}`,
      },
    };
    setTemplate(data);
    setRxModalShown(false);
    handleSetDataChanged(data);
  }

  useEffect(() => {
    componentDidMount();
    localStorage.setItem(`${patientId}_progressnote`, JSON.stringify(temp));
    if (temp.objectId) {
      handleSetDataChanged(template);
    }
    if (progressNoteId && !temp.objectId) {
      getProgressNote(progressNoteId)(dispatch).then(
        (res) => {
          setTemplate(res);
          getProgressNotesPlans(res.planIds)(dispatch);
        },
        (err) => {
          console.log(err);
        }
      );
    } else {
      getProgressNotesPlans(planIds)(dispatch);
    }
  }, [isOpen, progressNoteId]);

  function componentDidMount() {
    if (isOpen) {
      localStorage.setItem("someModalIsOpen", "true");
      $(modalId).modal({
        backdrop: "static",
        keyboard: false,
      });
      $(modalId).modal("show");
    } else {
      $(modalId).modal("hide");
    }
  }

  return (
    <form id="soap-template-from" className="needs-validation" novalidate>
      <div
        id="soap_progressnote_modal"
        className="modal fade"
        tabIndex="-1"
        role="dialog"
      >
        <div
          className="modal-dialog"
          role="document"
          style={{ maxWidth: "1200px" }}
        >
          <div className="modal-content modal-full-height">
            <div className="modal-header">
              <h5
                className="modal-title hc-primary-text"
                style={{ fontSize: "1.25rem" }}
              >
                <i className="fas fa-fw fa-file-contract"></i>
                {title}&nbsp;&nbsp;
                {!progressNoteId ? (
                  isDraftSaving ? (
                    <i style={{ margin: "5px", fontSize: 12 }} className="fa fa-spinner fa-spin"></i>
                  ) : (
                    dataChanged ? (
                      // <i className="fas fa-check ml-2 btn-outline-success" title="Draft saved"></i>
                      <span class="badge badge-secondary" 
                        style={{
                          fontWeight: "400",
                          fontSize: "50%"
                        }}>
                          Draft saved
                      </span>
                    ) : (
                      ""
                    ))
                ) : null }
              </h5>
              <button
                type="button"
                className="close"
                aria-label="Close"
                disabled={isDraftSaving}
                onClick={() => {
                  if (dataChanged) {
                    setShowSaveChanges(true);
                  } else {
                    handleClose();
                    onClose();
                  }
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ overflowY: "auto" }}>
              <div className="pn-container">
                <div className="pn-header">
                  <span>Vital Health Medical Group</span>
                  <span className="hc-primary-text">
                    6245 2nd flr De Longpre Ave, Hollywood, CA 90028
                  </span>
                  <span className="hc-primary-text">
                    Tel no. (323)315-0911 Fax (323)
                  </span>
                </div>
                <PatientInfo
                  patientInfo={patient}
                  visitProvider={visitProvider}
                  clinicLocation={clinicLocation}
                  dateSeen={dateSeen}
                  isDisabled={isAddendumNote}
                  updateAnyInPatient={(e) => handleUpdateField(e)}
                  updatePatientInfo={(name, value) =>
                    handleUpdatePatientInfo(name, value)
                  }
                  handleUpdatePNdraft={handleUpdatePNdraft}
                />
                <ChiefComplaints
                  chiefComplaints={chiefComplaints}
                  isDisabled={isAddendumNote}
                  updateChiefComplaints={(data) =>
                    handleUpdateChiefComplaints(data)
                  }
                  removeChiefComplaint={(data) =>
                    handleRemoveChiefComplaint(data)
                  }
                  handleUpdatePNdraft={handleUpdatePNdraft}
                />
                <Subjective
                  subjective={subjective}
                  isDisabled={isAddendumNote}
                  updateSubjective={(e) => handleUpdateField(e)}
                  clearField={(name) => handleClearField(name)}
                  handleUpdatePNdraft={handleUpdatePNdraft}
                />
                <VitalSigns
                  vitalSigns={vitalSigns}
                  isDisabled={isAddendumNote}
                  updateVitalSigns={(name, value) =>
                    handleUpdateVitalSigns(name, value)
                  }
                  handleUpdatePNdraft={handleUpdatePNdraft}
                />
                <Objective
                  objective={objective}
                  isDisabled={isAddendumNote}
                  updateObjective={(e) => handleUpdateField(e)}
                  clearField={(name) => handleClearField(name)}
                  handleUpdatePNdraft={handleUpdatePNdraft}
                />
                <Assessment
                  assessment={assessment}
                  isDisabled={isAddendumNote}
                  updateAssessment={(e) => handleUpdateField(e)}
                  clearField={(name) => handleClearField(name)}
                  handleUpdatePNdraft={handleUpdatePNdraft}
                />
                <PlanText
                  plan={plan}
                  isDisabled={isAddendumNote}
                  updatePlanText={(e) => handleUpdateField(e)}
                  clearField={(name) => handleClearField(name)}
                  handleUpdatePNdraft={handleUpdatePNdraft}
                />
                <Orders
                  prescriptions={patientInfo.medications || []}
                  planIds={planIds}
                  favorites={favorites}
                  plansArray={plansArray}
                  labs={labs}
                  isDisabled={isAddendumNote}
                  openPrescription={() => setRxModalShown(true)}
                  updatePlans={handleUpdatePlans}
                  updatePlansCheckbox={handleUpdatePlansCheckbox}
                  thread={{ ...patientInfo, threadId: patientInfo.objectId }}
                  guests={guests}
                  options={groupMembers}
                  isPatient={true}
                  patientName={patientInfo.name}
                  patientDob={patientInfo.dob}
                  handleUpdatePNdraft={handleUpdatePNdraft}
                />
                {isAddendumNote && (
                  <AddendumNote
                    addendumNote={addendumNote}
                    updateAddendumNote={(e) => handleUpdateField(e)}
                    clearField={(name) => handleClearField(name)}
                    handleUpdatePNdraft={handleUpdatePNdraft}
                  />
                )}
                <ProcedureNotes
                  procedureNotes={procedureNotes}
                  isDisabled={isAddendumNote}
                  updateProcedureNotes={(e) => handleUpdateField(e)}
                  handleUpdatePNdraft={handleUpdatePNdraft}
                />
                <hr />
                <div className="two-columns">
                  <FollowUps
                    followUps={followUps}
                    isDisabled={isAddendumNote}
                    updateFollowUps={(name, value) =>
                      handleUpdateFollowUps(name, value)
                    }
                    handleUpdatePNdraft={handleUpdatePNdraft}
                  />
                  <CptCode
                    encounterType={encounterType}
                    cptCode={cptCode}
                    modifierCode={modifierCode}
                    isDisabled={isAddendumNote}
                    updateCpt={(name, value, options) =>
                      handleUpdateCptComp(name, value, options)
                    }
                    handleUpdatePNdraft={handleUpdatePNdraft}
                  />
                </div>
                <div style={{ height: "1px" }} />
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group">
                {temp.status !== "DONE" && (
                  <button
                    type="button"
                    className="btn btn-hubchart btn-hubchart-success"
                    style={{ marginRight: "10px" }}
                    disabled={isDraftSaving}
                    onClick={() => {
                      const status = { status: "DONE" };
                      const isValid = checkFormValidity("soap-template-from");
                      if (!isValid) {
                        errorNotification();
                        return;
                      }

                      if (progressNoteId) {
                        handleUpdateProgressNote(status);
                      } else {
                        handleCreateProgressNote(status);
                      }
                    }}
                  >
                    Sign as Complete
                  </button>
                )}
                <button
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-hubchart btn-hubchart-primary"
                  disabled={isDraftSaving}
                  onClick={() => {
                    const isValid = checkFormValidity("soap-template-from");
                    if (!isValid) {
                      errorNotification();
                      return;
                    }

                    if (progressNoteId) {
                      handleUpdateProgressNote();
                    } else {
                      handleCreateProgressNote();
                    }
                  }}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-hubchart btn-hubchart-close"
                  disabled={isDraftSaving}
                  onClick={() => {
                    if (dataChanged) {
                      setShowSaveChanges(true);
                    } else {
                      handleClose();
                      onClose();
                      setLocalStorageNull();
                    }
                  }}
                >
                  Close
                </button>
              </div>
            </div>
            {isUpdating && (
              <div className="tab-loading">
                <Spinner size={5} color={"#fbba09"} loading={true} />
              </div>
            )}
            {showSaveChanges && (
              <SaveChanges
                onClose={(bool) => {
                  const isValid = checkFormValidity("soap-template-from");
                  handleSaveChangesOnClose(bool, isValid);
                }}
                title="Confirm Navigation"
                message="Some changes were made to this progress note. Do you want to save before closing?"
              />
            )}
          </div>
        </div>
        {rxModalShown && (
          <PrescriptionModal
            threadId={patientId}
            isOpen={rxModalShown}
            onClose={() => setRxModalShown(false)}
            refreshData={() => {}}
            importPrescription={(data) => handleImportedPrescription(data)}
            fromProgressNotes={true}
          />
        )}
      </div>
    </form>
  );
}

const mySelector = (state) => ({
  isUpdating: state.notes.isUpdating,
  plansArray: state.notes.plans,
});

export default SoapProgressNoteModal;
